export default {
  auth_request(state) {
    state.status = 'loading';
  },
  auth_success(state, { data }) {
    state.status = 'success';
    state.isApiKey = data.isApiKey;
    state.isImpersonating = !!data.originalToken || !!data.isImpersonating;
    state.user = data.user;
    state.twoFactorSetup = data.twoFactorSetup || {
      required: false,
      state: 'completed',
      completed: true,
      setupRequired: false,
    };
    state.access = data.access;
    state.primaryScopeIds = data.primaryScopeIds;
    state.primaryTenantIds = data.primaryTenantIds;
    state.tenantId = data.tenantId;
    state.tenantIdThemeSetting = data.user.properties.tenantIdThemeSetting;
  },
  verify_failed(state) {
    state.status = 'error';
  },
  logout(state) {
    state.status = '';
    state.isImpersonating = false;
    state.user = {};
    state.twoFactorSetup = {
      required: false,
      state: 'completed',
      completed: true,
      setupRequired: false,
    };
    state.access = [];
  },
};
